import { render, staticRenderFns } from "./VesselInquiryPop.vue?vue&type=template&id=a388435a"
import script from "./VesselInquiryPop.vue?vue&type=script&lang=js"
export * from "./VesselInquiryPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a388435a')) {
      api.createRecord('a388435a', component.options)
    } else {
      api.reload('a388435a', component.options)
    }
    module.hot.accept("./VesselInquiryPop.vue?vue&type=template&id=a388435a", function () {
      api.rerender('a388435a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/common/popup/VesselInquiryPop.vue"
export default component.exports